import createIcon from '../../createIcon';

/**
 * @component @name FilterAltOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNDk5NiA0Ljg5OTk4QzIxLjAwOTYgNC4yMzk5OCAyMC41Mzk2IDMuMjg5OTggMTkuNzA5NiAzLjI4OTk4SDcuNTM5NjFMMTUuNTA5NiAxMS4yNkwyMC40OTk2IDQuODk5OThaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMy41MTk2MSAyLjA5OTk4TDIuMDk5NjEgMy41MDk5OEwxMC43MDk2IDEyLjI5VjE4LjI5QzEwLjcwOTYgMTguODQgMTEuMTU5NiAxOS4yOSAxMS43MDk2IDE5LjI5SDEzLjcwOTZDMTQuMjU5NiAxOS4yOSAxNC43MDk2IDE4Ljg0IDE0LjcwOTYgMTguMjlWMTYuMTJMMjAuNDg5NiAyMS45TDIxLjg5OTYgMjAuNDlMMy41MTk2MSAyLjA5OTk4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FilterAltOff = createIcon('FilterAltOff', [
  [
    'path',
    {
      d: 'M20.4996 4.89998C21.0096 4.23998 20.5396 3.28998 19.7096 3.28998H7.53961L15.5096 11.26L20.4996 4.89998Z',
      key: '1esk5g',
    },
  ],
  [
    'path',
    {
      d: 'M3.51961 2.09998L2.09961 3.50998L10.7096 12.29V18.29C10.7096 18.84 11.1596 19.29 11.7096 19.29H13.7096C14.2596 19.29 14.7096 18.84 14.7096 18.29V16.12L20.4896 21.9L21.8996 20.49L3.51961 2.09998Z',
      key: 'hy5g80',
    },
  ],
]);

export default FilterAltOff;
